import { useContext } from 'react';
import { useLanguageData } from '../../../../hooks/useLanguageData';
import Switch from '../switch/Switch';
import { COOKIE_STATUS_DETAILS } from '../../../../constants/cookie';
import {
	CookieConsentWrapper,
	CookieElementConsentWrapper,
	Subtitle,
	Title,
} from './CookieConsentManagement.styles';
import { CookieContext } from '@/common/contexts/CookieContext';

const CookieConsentManagement = () => {
	const data = useLanguageData('cookie');
	const { setCookieDetails, cookieDetails } = useContext(CookieContext);

	const handleSwitch = (value, status) => {
		if (value) {
			return setCookieDetails((cookieStatuses) => [
				...cookieStatuses.filter((c) => c != status),
				status,
			]);
		}

		setCookieDetails((cookieStatuses) => [
			...cookieStatuses.filter((c) => c != status),
		]);
	};

	return (
		<CookieConsentWrapper>
			<CookieElementConsentWrapper>
				<div>
					<Switch id={1} disabled={true} defaultCheck={true} />
				</div>
				<div>
					<Title>{data.necessary.top}</Title>
					<Subtitle>{data.necessary.text}</Subtitle>
				</div>
			</CookieElementConsentWrapper>
			<CookieElementConsentWrapper>
				<div>
					<Switch
						id={2}
						onChange={(value) =>
							handleSwitch(value, COOKIE_STATUS_DETAILS.FUNCTIONAL)
						}
						defaultCheck={cookieDetails.includes(
							COOKIE_STATUS_DETAILS.FUNCTIONAL,
						)}
					/>
				</div>
				<div>
					<Title>{data.functional.top}</Title>
					<Subtitle>{data.functional.text}</Subtitle>
				</div>
			</CookieElementConsentWrapper>
			<CookieElementConsentWrapper>
				<div>
					<Switch
						id={3}
						onChange={(value) =>
							handleSwitch(value, COOKIE_STATUS_DETAILS.ANALYTICAL)
						}
						defaultCheck={cookieDetails.includes(
							COOKIE_STATUS_DETAILS.ANALYTICAL,
						)}
					/>
				</div>
				<div>
					<Title>{data.analytical.top}</Title>
					<Subtitle>{data.analytical.text}</Subtitle>
				</div>
			</CookieElementConsentWrapper>
			<CookieElementConsentWrapper>
				<div>
					<Switch
						id={4}
						onChange={(value) =>
							handleSwitch(value, COOKIE_STATUS_DETAILS.MARKETING)
						}
						defaultCheck={cookieDetails.includes(
							COOKIE_STATUS_DETAILS.MARKETING,
						)}
					/>
				</div>
				<div>
					<Title>{data.marketing.top}</Title>
					<Subtitle>{data.marketing.text}</Subtitle>
				</div>
			</CookieElementConsentWrapper>
			<CookieElementConsentWrapper>
				<div>
					<Switch
						id={5}
						onChange={(value) =>
							handleSwitch(value, COOKIE_STATUS_DETAILS.PERSONALIZATION)
						}
						defaultCheck={cookieDetails.includes(
							COOKIE_STATUS_DETAILS.PERSONALIZATION,
						)}
					/>
				</div>
				<div>
					<Title>{data.personalization.top}</Title>
					<Subtitle>{data.personalization.text}</Subtitle>
				</div>
			</CookieElementConsentWrapper>
		</CookieConsentWrapper>
	);
};

export default CookieConsentManagement;
